import React from "react";

interface SkeletonProps {
  height?: number | string;
  width?: number | string;
  borderRadius?: number | string;
}

const SkeletonAbout: React.FC<SkeletonProps> = ({
  height = 100,
  width = "100%",
  borderRadius = 8,
}) => {
  return (
    <div
      style={{
        height,
        width,
        borderRadius,
        background: "linear-gradient(90deg, #e0e0e0, #f5f5f5, #e0e0e0)",
        backgroundSize: "400% 400%",
        animation: "skeletonLoading 1.4s ease infinite",
      }}
    />
  );
};

export default SkeletonAbout;